import { Card } from '@trafiflow/shared-ui'
import { Building2, Search, TrendingUp, ExternalLink, Plus } from 'lucide-react'

export function Brands() {
  const trackedBrands = [
    { id: 1, name: 'Nike', industry: 'Sportswear', adsCount: 156, growth: '+12%' },
    { id: 2, name: 'Apple', industry: 'Technology', adsCount: 89, growth: '+8%' },
    { id: 3, name: 'Coca-Cola', industry: 'Beverages', adsCount: 234, growth: '+15%' },
    { id: 4, name: 'Samsung', industry: 'Electronics', adsCount: 178, growth: '+5%' },
    { id: 5, name: 'Amazon', industry: 'E-commerce', adsCount: 312, growth: '+22%' },
    { id: 6, name: 'McDonald\'s', industry: 'Food & Beverage', adsCount: 145, growth: '+9%' },
  ]

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-tf-text">Brands</h1>
          <p className="text-tf-text-muted mt-1">
            Track and analyze competitor brands and their advertising strategies
          </p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
          <Plus className="w-4 h-4" />
          <span>Track Brand</span>
        </button>
      </div>

      {/* Search */}
      <div className="relative mb-6">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-tf-text-muted" />
        <input
          type="text"
          placeholder="Search brands..."
          className="w-full pl-10 pr-4 py-2.5 border border-tf-border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      {/* Stats Overview */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        <Card className="p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <Building2 className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-tf-text">24</p>
              <p className="text-sm text-tf-text-muted">Tracked Brands</p>
            </div>
          </div>
        </Card>
        <Card className="p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
              <TrendingUp className="w-5 h-5 text-green-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-tf-text">1,234</p>
              <p className="text-sm text-tf-text-muted">Total Ads Tracked</p>
            </div>
          </div>
        </Card>
        <Card className="p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary/15 rounded-lg flex items-center justify-center">
              <ExternalLink className="w-5 h-5 text-primary" />
            </div>
            <div>
              <p className="text-2xl font-bold text-tf-text">8</p>
              <p className="text-sm text-tf-text-muted">Industries Covered</p>
            </div>
          </div>
        </Card>
      </div>

      {/* Brands List */}
      <div>
        <h2 className="text-lg font-semibold text-tf-text mb-4">Tracked Brands</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {trackedBrands.map((brand) => (
            <Card
              key={brand.id}
              className="p-4 hover:shadow-md transition-shadow cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-tf-bg-hover rounded-lg flex items-center justify-center text-lg font-bold text-tf-text-muted">
                  {brand.name.charAt(0)}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-tf-text">{brand.name}</h3>
                  <p className="text-sm text-tf-text-muted">{brand.industry}</p>
                  <div className="flex items-center gap-4 mt-2">
                    <span className="text-sm text-tf-text-muted">
                      <span className="font-medium">{brand.adsCount}</span> ads
                    </span>
                    <span className="text-sm text-green-600 font-medium">
                      {brand.growth}
                    </span>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Brands
